import React, { Component } from "react";
import MyTitle from "../../myTitle";
import styleObj from "../style.module.scss";
import styleObj2021 from "./style.module.scss";
import title from "../../../assets/imgs/live-2021.png";

export default class Live extends Component {
  render() {
    let { liveAddress } = this.props;
    return (
      <div className={styleObj["review-wrap"]}>
        <MyTitle {...this.props} title={title} />
        <div className={`${styleObj["content"]} ${styleObj2021["content"]}`}>
          <iframe
            title="skyworth w92 系列体验趴"
            src={liveAddress && liveAddress.replace(/https?:/, "")}
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen={true}
          ></iframe>
          <img
            className={styleObj["pendant"]}
            src={require("../../../assets/imgs/live stream2021.png")}
            alt=""
          />
          <img
            className={styleObj2021["yun"]}
            src={require("../../../assets/imgs/yun2021.png")}
            alt=""
          />
        </div>
      </div>
    );
  }
}
